export { default } from "./src/global-nav";
